import React, { useEffect, useState } from 'react';
import { reportAPI, offlineSaleAPI } from '../services/api';
import { StatCard, Badge, Spinner } from '../components/Common';

const DashboardPage = () => {
  const [data,       setData]       = useState(null);
  const [topProducts,setTopProducts]= useState([]);
  const [loading,    setLoading]    = useState(true);
  const [offlineStats, setOfflineStats] = useState(null);

  useEffect(() => {
    Promise.all([
      reportAPI.getDashboard(),
      reportAPI.getTopProducts(),
    ])
    .then(([dashRes, topRes]) => {
      setData(dashRes.data);
      setTopProducts(topRes.data.top_products || []);
    })
    .catch(console.error)
    .finally(() => setLoading(false));
    
    offlineSaleAPI.getStats().then(r => setOfflineStats(r.data)).catch(() => {});
  }, []);

  if (loading) return <Spinner />;

  const { stats, low_stock_products = [], recent_invoices = [] } = data || {};

  return (
    <div className="page">
      {low_stock_products.length > 0 && (
        <div className="low-stock-banner">
          ⚠️ <strong>{low_stock_products.length} products</strong> The stock is low!
        </div>
      )}

      <div className="stats-grid gstr-grid">
      <div className="stats-container">

        {/* Total Products */}
        <div className="stat-card stat-blue">
          <div className="icon">📦</div>
          <div className="details">
            <div className="value">{stats?.total_products}</div>
            <div className="label">Total Products</div>
            <div className="sub-text">
              {stats?.low_stock_count} low stock
            </div>
          </div>
        </div>

        {/* Low Stock */}
        <div className="stat-card stat-red">
          <div className="icon">⚠️</div>
          <div className="details">
            <div className="value">{stats?.low_stock_count}</div>
            <div className="label">Low Stock</div>
            <div className="sub-text">
              Reorder karo
            </div>
          </div>
        </div>

        {/* Stock Value */}
        <div className="stat-card stat-green">
          <div className="icon">💰</div>
          <div className="details">
            <div className="value">
              ₹{(stats?.total_stock_value || 0).toLocaleString('en-IN')}
            </div>
            <div className="label">Stock Value</div>
            <div className="sub-text">
              Selling price pe
            </div>
          </div>
        </div>

        {/* Today Sales */}
        <div className="stat-card stat-orange">
          <div className="icon">🛒</div>
          <div className="details">
            <div className="value">
              ₹{(stats?.today_revenue || 0).toLocaleString('en-IN')}
            </div>
            <div className="label">Today Sales</div>
            <div className="sub-text">
              {stats?.today_sales || 0} invoices

              {offlineStats?.today_total > 0 && (
                <span
                  style={{
                    fontSize: "10px",
                    color: "var(--accent)",
                    marginLeft: "6px",
                  }}
                >
                  + ₹{parseFloat(offlineStats.today_total).toLocaleString("en-IN")} offline
                </span>
              )}
            </div>
          </div>
        </div>

        </div>
        {/* <StatCard icon="📦" label="Total Products"
          value={stats?.total_products}
          sub={`${stats?.low_stock_count} low stock`}
          color="blue" />
        <StatCard icon="⚠️" label="Low Stock"
          value={stats?.low_stock_count}
          sub="Reorder karo"
          color="red" />
        <StatCard icon="💰" label="Stock Value"
          value={'Rs.' + (stats?.total_stock_value||0).toLocaleString('en-IN')}
          sub="Selling price pe"
          color="green" />
        <StatCard icon="🛒" label="Today Sales"
          value={'Rs.' + (stats?.today_revenue||0).toLocaleString('en-IN')}
          sub={
            <span>
              {stats?.today_sales||0} invoices
              {offlineStats?.today_total > 0 && (
                <span style={{ fontSize:10, color:'var(--accent)', marginLeft:6 }}>
                  + ₹{parseFloat(offlineStats.today_total).toLocaleString('en-IN')} offline
                </span>
              )}
            </span>
          }
          color="orange" /> */}
      </div>

      {/* Top Selling Products */}
      {topProducts.length > 0 && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="card-header">
            <span className="card-title">🏆 Top Selling Products</span>
            <Badge variant="blue">{topProducts.length} products</Badge>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Total Sold</th>
                  <th>Orders</th>
                  <th>Total Revenue</th>
                  <th>Performance</th>
                </tr>
              </thead>
              <tbody>
                {topProducts.map((p, idx) => {
                  const maxRevenue = parseFloat(topProducts[0]?.total_revenue || 1);
                  const pct = Math.round(parseFloat(p.total_revenue) / maxRevenue * 100);
                  return (
                    <tr key={p.product_id}>
                      <td>
                        <span style={{
                          fontWeight: 700,
                          color: idx === 0 ? '#FFD700'
                            : idx === 1 ? '#C0C0C0'
                            : idx === 2 ? '#CD7F32'
                            : 'var(--text3)',
                          fontSize: idx < 3 ? 16 : 13,
                        }}>
                          {idx === 0 ? '🥇' : idx === 1 ? '🥈' : idx === 2 ? '🥉' : `#${idx + 1}`}
                        </span>
                      </td>
                      <td><strong>{p.product_name}</strong></td>
                      <td>
                        <span style={{ color: 'var(--accent2)', fontWeight: 600 }}>
                          {parseFloat(p.total_qty_sold).toFixed(1)} {p.unit}
                        </span>
                      </td>
                      <td>
                        <Badge variant="blue">{p.total_orders} orders</Badge>
                      </td>
                      <td>
                        <strong style={{ color: 'var(--accent2)' }}>
                          Rs.{parseFloat(p.total_revenue).toLocaleString('en-IN')}
                        </strong>
                      </td>
                      <td style={{ width: 150 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div className="chart-bar" style={{ flex: 1 }}>
                            <div className="chart-fill" style={{
                              width: pct + '%',
                              background: idx === 0
                                ? 'linear-gradient(90deg, #FFD700, #FFA500)'
                                : 'var(--accent)',
                            }} />
                          </div>
                          <span style={{ fontSize: 11, color: 'var(--text3)', width: 32 }}>
                            {pct}%
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="two-col">
        {/* Low Stock */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">⚠️ Low Stock Products</span>
          </div>
          <div style={{ padding: 0 }}>
            {low_stock_products.length === 0 ? (
              <div style={{ padding: 24, textAlign: 'center', color: 'var(--text3)' }}>
                ✅ Sab stock theek hai!
              </div>
            ) : (
              <table>
                <tbody>
                  {low_stock_products.map(p => (
                    <tr key={p.id}>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ fontWeight: 600 }}>{p.name}</div>
                        <div style={{ fontSize: 12, color: 'var(--text3)' }}>{p.sku}</div>
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{
                          color: parseFloat(p.quantity) === 0
                            ? 'var(--danger)' : 'var(--warn)',
                          fontWeight: 700,
                        }}>
                          {p.quantity} {p.unit}
                        </span>
                      </td>
                      <td style={{ padding: '12px 16px' }}>
                        <Badge variant={parseFloat(p.quantity) === 0 ? 'red' : 'orange'}>
                          {parseFloat(p.quantity) === 0 ? 'Out of Stock' : 'Low'}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Recent Invoices */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">🕐 Recent Invoices</span>
          </div>
          <div style={{ padding: 0 }}>
            {recent_invoices.length === 0 ? (
              <div style={{ padding: 24, textAlign: 'center', color: 'var(--text3)' }}>
                Koi invoices nahi abhi tak
              </div>
            ) : (
              <table>
                <tbody>
                  {recent_invoices.map(inv => (
                    <tr key={inv.id}>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ fontWeight: 600, color: 'var(--accent)', fontSize: 13 }}>
                          {inv.invoice_number}
                        </div>
                        <div style={{ fontSize: 12, color: 'var(--text3)' }}>
                          {new Date(inv.createdAt).toLocaleDateString('en-IN')}
                        </div>
                      </td>
                      <td style={{ padding: '12px 16px', fontSize: 13 }}>
                        {inv.customer?.name || 'Walk-in'}
                      </td>
                      <td style={{ padding: '12px 16px', fontWeight: 700, color: 'var(--accent2)' }}>
                        Rs.{parseFloat(inv.total_amount).toLocaleString('en-IN')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;